import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { UilBars } from "@iconscout/react-unicons";
import "./Layout.css";

const Layout = ({ children, setIsAuthenticated }) => {
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setSidebarVisible(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="layout">
      <Sidebar
        setIsAuthenticated={setIsAuthenticated}
        expanded={sidebarVisible}
        setExpanded={setSidebarVisible}
      />

      <div className="layout-main">
        <div className="layout-topbar">
          <div
            className="layout-menu-btn"
            onClick={() => setSidebarVisible(!sidebarVisible)}
          >
            <UilBars size={28} />
          </div>
        </div>

        <main className="layout-content">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
